
export function isFulfilledResult<T>(
    result: PromiseSettledResult<T>
): result is PromiseFulfilledResult<T> {
  return result.status === 'fulfilled';
}

export function isRejectedResult<T>(
    result: PromiseSettledResult<T>
): result is PromiseRejectedResult {
  return result.status === 'rejected';
}
